import clsx from 'clsx';
interface ButtonProps {
  onClick?: () => void;
  text: string;
  style?: any;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean; // Add the disabled prop
  classNames?: string;
  bgColor?: string;
}

function PrimaryButton({
  onClick,
  text,
  style,
  type,
  disabled,
  classNames,
  bgColor,
}: ButtonProps) {
  return (
    <button
      onClick={onClick}
      style={style}
      type={type}
      disabled={disabled} // Set the button as disabled when needed
      className={clsx(
        `h-[48px] w-[auto] flex text-[white] items-center justify-center rounded-[200px] px-[24px] py-[16px] text-[16px] font-bold text-white transition-all ${
          disabled
            ? 'cursor-not-allowed bg-[gray] bg-opacity-30'
            : bgColor || 'bg-[#CD232E]'
        }`,
        classNames,
      )}>
      {text}
    </button>
  );
}

export default PrimaryButton;
